import { useUser } from "@clerk/clerk-react";
import { type ReactNode, useEffect } from "react";
import posthog from "@/lib/posthog";

export function PostHogProvider({ children }: { children: ReactNode }) {
  const { user, isLoaded } = useUser();

  useEffect(() => {
    if (!isLoaded) return;
    if (user) {
      posthog.identify(user.id);
    } else {
      posthog.reset();
    }
  }, [user, isLoaded]);

  return <>{children}</>;
}
